import React from "react";
import AppRouter from "./Router";
import { GuidedEnrollmentTrigger } from "./components/GuidedEnrollmentDrawer";

function App() {
  return (
    <>
      <AppRouter />
      <GuidedEnrollmentTrigger />
    </>
  );
}

export default App;
